export default "__VITE_ASSET__CKErZjn5__"